import React, {useState} from "react";
import {Badge, Button, ButtonGroup, OverlayTrigger, Tooltip} from "react-bootstrap";
import {BsLightningCharge, BsShieldCheck, BsTools} from "react-icons/bs";
import {useTranslation} from "react-i18next";
import {BookCallModal} from "./BooKCallModal";
import '../Home/Pricing.css';
import './PricingOptions.css';
import {RegisterModal} from "./RegisterModal";
import {I18nService} from "../../../service/i18nService";

const COLORS = {
    primary: "#263C91",
    highlight: "#D8426E",
    accent: "#F15434"
};

export const PricingOptions = () => {
    const {t, i18n} = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [isYearly, setIsYearly] = useState(false);
    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();

    const discount = 0.2;

    const formatPrice = (price) => isYearly
        ? <>
            <del className="text-muted me-2">€{(price * 12).toFixed(2)}</del>
            €{calculateDiscountedPrice(price).toFixed(2)}</>
        : <>€{price.toFixed(2)}</>;

    const calculateDiscountedPrice = (price) => price * (1 - discount) * 12;
    const renderTooltip = (text) => (
        <Tooltip>{text}</Tooltip>
    );

    const [registerModal, setRegisterModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState({});

    const pricingOptions = [
        {
            title: t("pages.common.personal.title"),
            price: 1,
            description: t("pages.common.personal.description"),
            tooltip: t("pages.common.personal.tooltip"),
            cta: t("pages.common.personal.cta"),
            icon: <BsTools/>,
            color: COLORS.primary,
            plan: 'personal',
            isYearly: isYearly,
            lang: currentLang
        },
        {
            title: t("pages.common.smb.title"),
            price: 34.99,
            description: t("pages.common.smb.description"),
            tooltip: t("pages.common.smb.tooltip"),
            cta: t("pages.common.smb.cta"),
            icon: <BsLightningCharge/>,
            color: COLORS.accent,
            plan: 'smb',
            isYearly: isYearly,
            lang: currentLang
        },
        {
            title: t("pages.common.enterprise.title"),
            price: 0,
            description: t("pages.common.enterprise.description"),
            tooltip: t("pages.common.enterprise.tooltip"),
            cta: t("pages.common.enterprise.cta"),
            icon: <BsShieldCheck/>,
            color: COLORS.highlight,
            plan: 'enterprise',
            isYearly: isYearly,
            lang: currentLang
        }
    ];

    return (
        <>
            <BookCallModal show={showModal} handleClose={() => setShowModal(false)}/>
            <RegisterModal show={registerModal}
                           onClose={() => setRegisterModal(false)}
                           option={selectedOption}
                           title="Start your subscription"
                           submitLabel="Continue to Payment"></RegisterModal>
            <section className="container bg-white pt-5 pb-5" aria-labelledby="pricing">
                <div className="text-center mb-4">
                    <h2 id="pricing" className="fw-bold">
                        {t("pages.common.pricing.title")}
                    </h2>
                    <p className="lead">{t("pages.common.pricing.subTitle")}</p>
                </div>

                <div className="text-center mb-4">
                    <ButtonGroup>
                        <Button variant={isYearly ? "outline-dark" : "dark"} onClick={() => setIsYearly(false)}>
                            {t("pages.common.pricing.monthly")}
                        </Button>
                        <Button variant={isYearly ? "dark" : "outline-dark"} onClick={() => setIsYearly(true)}>
                            {t("pages.common.pricing.yearly")} <small
                            className="ms-1 text-success">-{discount * 100}%</small>
                        </Button>
                    </ButtonGroup>
                </div>

                <div className="row g-4">
                    {pricingOptions.map((option, idx) => (
                        <div className="col-12 col-md-4" key={idx}>
                            <div
                                className="border rounded shadow-sm h-100 p-4 text-center hover-lift position-relative bg-white"
                                style={{transition: "all 0.2s ease-in-out"}}
                            >
                                {idx === 2 && (
                                    <Badge bg="success"
                                           className="position-absolute top-0 end-0 m-3 pulse-badge">
                                        {t("pages.common.enterprise.badge")}
                                    </Badge>
                                )}
                                <div className="mb-3" style={{fontSize: "2.5rem", color: option.color}}>
                                    {option.icon}
                                </div>
                                <h4 className="fw-bold mb-2">{option.title}</h4>
                                <p className="text-muted">
                                    <OverlayTrigger placement="top" overlay={renderTooltip(option.tooltip)}>
                                        <span>{option.description}</span>
                                    </OverlayTrigger>
                                </p>
                                <h6 className="fw-bold mb-3">
                                    {option.price > 0 ? formatPrice(option.price) : t("pages.common.enterprise.customPrice")}
                                </h6>
                                <button
                                    onClick={
                                        () => {
                                            setSelectedOption(option);

                                            if (option.plan === 'enterprise') {
                                                setShowModal(true);
                                            } else {
                                                setRegisterModal(true);
                                            }
                                        }
                                    }
                                    className="btn w-100"
                                    style={{
                                        backgroundColor: option.color,
                                        color: "#fff",
                                        border: "none"
                                    }}
                                >
                                    {option.cta}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-5 pt-4 border-top">
                    <p className="fw-bold mb-2">{t("pages.common.setupService.title")}</p>
                    <p className="text-muted mb-3">{t("pages.common.setupService.description")}</p>
                    <button onClick={() => setShowModal(true)} className="btn btn-warning">
                        {t("pages.common.setupService.cta")}
                    </button>
                </div>
            </section>
        </>
    );
};
